<style lang="less">
.canvasdemo{
	background: #f2f2f2;
	padding: 10px 0;
	.tit{
		font-size: 16px;
		font-weight: 700;
		padding: 10px;
		text-align: center;
	}
	.char_content{
		width: 100%;
		height: 300px;
		background: #eee;
		canvas{
			width: 360px;
			height: 240px;
			background: #fff;
		}
	}
}
</style>

<template>
	<!-- Main canvas -->
	<section class="canvasdemo">
		<h2 class="tit">拆线图 Demo</h2>
		<div class="char">
			<div class="content">
				<char :charData="charData"></char>
			</div>
		</div>
	</section>
</template>

<script>
	import android from '@flyme/jr/js/android.js';

	import char from '../components/char_2.vue';

	export default {
		data: function () {
			return {
				charData: {}
			};
		},
		components: {
			char
		},
		mounted: function () {
			android('stopLoading');

			var history_rates = [{
									"date": 1530028800000,
									"rate": 3.8460
								}, {
									"date": 1529942400000,
									"rate": 3.8740
								}, {
									"date": 1529856000000,
									"rate": 3.8440
								}, {
									"date": 1529769600000,
									"rate": 3.8460
								}, {
									"date": 1529683200000,
									"rate": 3.8490
								}, {
									"date": 1529596800000,
									"rate": 3.8520
								}, {
									"date": 1529510400000,
									"rate": 3.8480
								}];
			this.getCharData(history_rates);

			// history_rates[3].rate = 6.5;
			// setInterval(function () {
			// 	this.ranNum();
			// }.bind(this), 2000);

		},
		methods: {
			ranNum: function () {
				var temp = [];
				var smooth = 0.5;
				for( var i = 0; i< 7; i++){
					temp.push({
						"date": 1530028800000 + 86400000 * i,
						"rate": 3.9000 + Math.round(Math.random() * smooth * 10000) / 10000
					});
				}
				this.getCharData(temp);
			},
			getCharData: function (data) {
				// var charData = {
				// 	x: [],
				// 	y: []
				// };
				// for( var i = 0; i < data.length; i++){
				// 	charData.x.push(new Date(data[i].date).Format("MM/dd"));
				// 	charData.y.push(data[i].rate);
				// }
				// this.charData = charData;
				var charData = {
					x: [],
					y: []
				};
				for( var i = 0; i < data.length; i++){
					charData.x.push(new Date(data[i].date).Format("MM/dd"));
					charData.y.push(data[i].rate);
				}
				if (charData.x.length > 7) {
					charData.x = charData.x.slice(-7);
					charData.y = charData.y.slice(-7);
				}
				this.charData = charData;

			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Canvas.vue